import { Access } from "@p0security/shared/types/access/index";

import {
  aliasParameter,
  groupDestinationParameter,
  groupNameParameter,
  parentParameter,
  requiredProviderParameter,
  sudoParameter,
} from "./parameters.ts";

export const commonSshAccess: Readonly<
  Record<"description" | "label", string>
> = {
  description: "SSH session instance",
  label: "Single instance",
};

export const commonGroupAccess = (parentLabel: string) =>
  Access({
    description: "Ability to SSH into any instance in a group",
    label: "Instance group",
    maturity: "ga",
    delegation: {},
    generated: {
      name: {
        type: "string",
      },
    },
    parameters: {
      provider: { ...requiredProviderParameter, optional: true },
      parent: parentParameter(parentLabel),
      name: groupNameParameter,
      destination: groupDestinationParameter,
      sudo: sudoParameter,
      alias: aliasParameter,
      key: {
        type: "generated",
        label: "Group key",
      },
    },
    render: { locator: "parent", resource: "name", policy: "sudo" } as const,
  });
